export default __webpack_public_path__ + "static/media/folder.5fa0b9f7.svg";